export default __webpack_public_path__ + "static/media/runner.0c28e02d.jpg";